module.exports = __webpack_public_path__ + "static/footer-logo-ddc54649be98f6afe20179da9856126a.png";